import es from '@/locales/es.json';
import pt from '@/locales/pt.json';
import en from '@/locales/en.json';

export default { es, pt, en };
